import { requestApi } from "app/utils/RestApi";
import { config } from "../../../app/config/main";
import { AUTH } from "app/utils/constants/endPoint";

export const storeToken = (token) => {
    localStorage.setItem('token', token);
    if (!config?.authSetting?.axiosObject)
        throw Error("axiosObject need to be set under authSettings inside app/config/main.js");
    else
        config.authSetting.axiosObject.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

export const removeToken = async () => {
    clearUserSession()
    window.history.replaceState(null, null, "/");
    window.location.href = '/micrositeLogin'
};

export const clearUserSession = async () => {
    sessionStorage.removeItem("auth")
    sessionStorage.removeItem("otp_temp_encypted_str");
    localStorage.removeItem('program');
    localStorage.removeItem('token');
    localStorage.removeItem('mfa_pending');
    localStorage.removeItem('userdata');
    localStorage.removeItem('username');
    localStorage.removeItem('otpOnly');
    localStorage.removeItem('mfa_channel');
    localStorage.removeItem('mfa_ttl_exp');
    localStorage.removeItem('post_mfa_next');
    localStorage.removeItem('otpOnly')
    localStorage.removeItem('edit_profile_referrer')
};

export const removeOtpSession = () => {
    localStorage.removeItem("temp_token")
    localStorage.removeItem("success_otp")
    localStorage.removeItem('ref_otp_exp')
    localStorage.removeItem('expiryTime');
    localStorage.removeItem('restartCount');
    localStorage.removeItem('restartAvailableTime')

    const actionTypes = ['TNC_REGIS', 'LOGIN', 'PROFILE_EDIT'];
    actionTypes.forEach(at => {
        localStorage.removeItem(`ref_otp_exp_${at}`);
        localStorage.removeItem(`expiryTime_${at}`);
        localStorage.removeItem(`restartCount_${at}`);
        localStorage.removeItem(`restartAvailableTime_${at}`);
    });
};